import { useQuery } from '@tanstack/react-query'
import { fetchWorkflowTrace } from '@/services/api/workflowTraces'

export function useWorkflowTrace(entryType: string | null, entryId: string | null) {
  return useQuery({
    queryKey: ['workflow-traces', entryType, entryId],
    queryFn: () => fetchWorkflowTrace(entryType!, entryId!),
    enabled: !!entryType && !!entryId,
  })
}